<template>
  <div class="addPro">
    <div class="title">
      <!--Exhibitor Registration-->
      <p>
        <img :src="banner" style="width: 80%;" />
      </p>
    </div>
    <div style="padding-bottom:20px">
      <el-row>
        <el-col :span="18" :offset="3">
          <el-form style="margin-top: 30px;" :model="form" :rules="rules" ref="singUp" label-position="right" size="small" label-width="210px">
            <el-form-item label="Registration" prop="exhId" :rules="{ required:true, trigger: 'change', message: 'Please select'}" >
              <el-select v-model="form.exhId" placeholder="">
                <el-option :label="val.exheName || val.exhsName" :value="val.exhID" v-for="(val) in exhibitionList" :key="val.exhID"></el-option>
              </el-select>
            </el-form-item>
            <template v-for="(item,ind) in formList.list">
              <template v-if="item.fieldKey != 'alyCountry' && item.fieldKey != 'alyBthType'  && item.fieldKey != 'alyProvince'  && item.fieldKey != 'alyCity' && item.fieldKey != 'alyArea' && item.fieldKey != 'alyCardNum'  && item.fieldKey != 'alyLogo' && item.fieldKey != 'alyPdtType' && item.fieldKey !=='alyQQ'">
                <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
                  <template v-if="item.fieldKey == 'alyTel' || item.fieldKey == 'alyFax' || item.fieldKey == 'aLyLegalTel' || item.fieldKey == 'aLyLegalFax'">
                    <el-input v-model.trim="form[item.fieldKey]" :placeholder="item.fieldHolder"></el-input>
                  </template>
                  <template v-else-if="item.fieldKey == 'alyWebUrl'">
                    <el-input v-model.trim="form[item.fieldKey]" :placeholder="item.fieldHolder"></el-input>
                  </template>
                  <template v-else-if="item.fieldKey == 'alyComEName' || item.fieldKey == 'alyComName' ||item.fieldKey == 'alyEAddress' || item.fieldKey == 'alyAddress' || item.fieldKey == 'alyPsnName'">
                    <el-input :type=" ( item.fieldKey == 'alyPdtInfo' ) ? 'textarea': 'text'" v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" @blur="trimInput(item.fieldKey)"></el-input>
                  </template>
                  <template v-else>
                    <el-input :type=" ( item.fieldKey == 'alyPdtInfo' ) ? 'textarea': 'text'" v-model.trim="form[item.fieldKey]" :placeholder="item.fieldHolder"></el-input>
                  </template>
                </el-form-item>
              </template>

              <!-- 展位面积 -->
              <template v-if="item.fieldKey == 'alyArea' || item.fieldKey == 'alyCardNum' || item.fieldKey == 'alyQQ'">
                <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
                  <el-input   v-model.trim="form[item.fieldKey]" @keyup.native="inputChange($event,item.fieldKey)" :placeholder="item.fieldHolder"></el-input>
                </el-form-item>
              </template>
              <!-- 展位类型 -->
              <template v-if="item.fieldKey == 'alyBthType'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder">
                    <el-option v-for="(item, index) in bthTypeList" :key="index" :label="item.typeEN" :value="item.typeCN"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <!-- 产品类型 -->
              <template v-if="item.fieldKey == 'alyPdtType'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder">
                    <el-option :label="val.typName" :value="val.typID" v-for="(val) in classTypeList" :key="val.typID"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-if="item.fieldKey == 'alyCountry'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" @change='changeCountry' filterable no-match-text="No matching data">
                    <el-option v-for="(item, index) in countryList" :key="index" :label="item.zptECity" :value="item.zptCity"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-if="item.fieldKey == 'alyProvince'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :key="ind"  :rules="rulesFn(item)">
                  <el-select v-model="form[item.fieldKey]" :placeholder="item.fieldHolder" @change='changeProvince' :disabled="provinceList.length<=0">
                    <el-option v-for="(item, index) in provinceList" :key="index" :label="item.zptProvince" :value="item.zptProvince"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-if="item.fieldKey == 'alyCity'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey"  :key="ind"  :rules="rulesFn(item)">
                  <el-select v-model="form[item.fieldKey]"  :placeholder="item.fieldHolder" :disabled="citysList.length<=0">
                    <el-option v-for="(item, index) in citysList" :key="index" :label="item.zptCity" :value="item.zptCity"></el-option>
                  </el-select>
                </el-form-item>
              </template>

              <template v-if="item.fieldKey == 'alyLogo'">
                <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                  <el-input v-model="form[item.fieldKey]" style="display:none"/>
                  <Upload :isFaceRead="false" :mediaUrl.sync="form[item.fieldKey]" :needToken="true"  :typeString = '"E"'/>
                </el-form-item>
              </template>
            </template>
            <!-- <div style='text-align:center'><el-checkbox v-model="registerFlan" @change="changeCheck"><span style="text-decoration:underline;color:#409EFF">注册协议</span></el-checkbox></div> -->
            <div style="text-align:center; padding: 18px 0;">
              <el-button :style="buttonStyle" size="medium" type="primary" @click="onSubmit" :disabled='subimtStatu'>Submit</el-button>
            </div>
          </el-form>
          <div class="registBox" v-if="showRegistText" >
            <div class="registContent">
              <div class="icon" @click="closeTip"><i class="el-icon-close"></i></div>
              <p class="smallTitle"> 注册协议</p>
              <p> 【审慎阅读】您在申请注册流程中点击同意前，应当认真阅读以下协议。请您务必审慎阅读、充分理解协议中相关条款内容，其中包括：</p>
              <p> 1、与您约定免除或限制责任的条款；</p>
              <p> 2、与您约定法律适用和管辖的条款；</p>
              <p> 3、其他以粗体下划线标识的重要条款。</p>
              <p> 如您对协议有任何疑问，可向平台客服咨询。</p>
              <p> 【特别提示】当您按照注册页面提示填写信息、阅读并同意协议且完成全部注册程序后，即表示您已充分阅读、理解并接受协议的全部内容。如您因平台服务与淘宝发生争议的，适用《平台服务协议》处理。如您在使用平台服务过程中与其他用户发生争议的，依您与其他用户达成的协议处理。</p>
              <p> 阅读协议的过程中，如果您不同意相关协议或其中任何条款约定，您应立即停止注册程序。</p>
              <p> 隐私权政策</p>
              <p> 法律声明</p>
            </div>

          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '@/utils/tools.js';
import Upload from '@/components/Upload'
import { validateComName, validateName, validateRank, validateAddress, validateWebUrl, validateEnCompany, validateChineseZipCode,validateTelele,validatePassword, validateEmail,validateMobile,validateCoutry01 ,} from '@/utils/validator'
import banner from '@/assets/banner.png'
export default {
  components: {
    Upload
  },
  data () {
    return {
      banner: banner,
      exhId: `${this.$route.query.ExhID}` === 'undefined' ? '' : `${this.$route.query.ExhID}`,
      formList:{
        list:[]
      },
      form:{
        alyID: '',
        alyProvince: '',
        alyCity: '',
        alyCardNum: 0,
        exhId: ''
      },
      actorRules: {},
      countryList: [],
      provinceList: [],
      citysList: [],
      bthTypeList: [{typeCN:'标摊',typeEN:'Standard Booth'}, {typeCN:'光地',typeEN:'Raw Space Booth'}],
      rules:{},
      subimtStatu:false,
      registerFlan:false,
      showRegistText:false,
      loading:'',
      classTypeList:[],
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      exhibitionList:[{
        exheName: "CropProtection",
        exhID: 10819
      },{
        exheName: "FSHOW",
        exhID: 10820
      },{
        exheName: "CACE",
        exhID: 10821
      },{
        exheName: "Agtech",
        exhID: 10822
      }]
    }
  },
  mounted() {
    this.loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    this.getexhibitionlist()
    this.getregisterconfig()
    this.getCountrys()
    // 没有国家时直接也允许修改省份和城市
    this.getallprovinces()
    this.getProductType()
  },
  methods: {
    trimInput(fieldKey) {
      // console.log(this.form,'trimInput---')
      this.form[fieldKey] = this.form[fieldKey].trim();
    },
    // 获取关联展会列表
    getexhibitionlist(){
      api.getexhibitionlist().then((res)=>{
        if(res.data.code =='200'){
          // console.log(res.data)
          // this.exhibitionList = res.data.data
        }
      })
    },
    //获取展品分类
    getProductType(){
      api.searchproducttype().then((res)=>{
        if(res.data.code =='200'){
          var _data = res.data.data
          this.classTypeList = _data
        }
      })
    },
    inputChange(ev,val){
      this.form[val] = this.form[val].replace(/[^\d]/g,'');
    },
    validateProvince (rule, value, callback) {
      if (rule.required) { // 如果省份必填
        if (this.form.alyCountry === '中国' || this.form.alyCountry === undefined) { // 已选择中国或没有国家选项
          if (!value) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    validateCity (rule, value, callback) {
      if (rule.required) {
        if (this.form.alyProvince) {
          if (!value) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    rulesFn(item){
      var temp = ''
      var rulesData= {
        alyCountry: [{ required: item.required, trigger: 'change', message: 'Please choose '+item.fieldName}],
        alyProvince:[{ required: item.required, trigger: 'change', message: 'Please choose '+item.fieldName,validator: this.validateProvince}],
        alyCity:[{ required: item.required, trigger: 'change', message: 'Please choose '+item.fieldName,validator: this.validateCity}],
        alyZipCode: [{ required: item.required, trigger: 'blur', message: "Enter correctly "+item.fieldName, validator: validateChineseZipCode }],
        alyAddress: [{ required: item.required, trigger: 'blur', message: item.fieldName+' enter 6-200 characters', validator: validateAddress}],
        alyLogo: [{ required: item.required, trigger: 'change', message: item.fieldName}],
        alyFax: [{ required: item.required, trigger: 'blur', message: "Enter correctly "+item.fieldName,validator: validateTelele}],
        alyTel: [{ required: item.required, trigger: 'blur', message: "Enter correctly "+item.fieldName,validator: validateTelele}],
        aLyLegalFax: [{ required: item.required, trigger: 'blur', message: "Enter correctly "+item.fieldName,validator: validateTelele}],
        aLyLegalTel: [{ required: item.required, trigger: 'blur', message: "Enter correctly "+item.fieldName,validator: validateTelele}],
        alyComName: [{ required: item.required, trigger: 'blur',message: item.fieldName+' enter 4-100 characters', validator: validateComName}],
        alyName: [{ required: item.required, trigger: 'blur',message: item.fieldName+' enter 2-20 Chinese characters or 2-50 English characters', validator: validateName}],
        alyPosition: [{ required: item.required, trigger: 'blur',message: 'Enter correctly '+item.fieldName, validator: validateRank}],
        alyMobile: [{ required: item.required, trigger: 'blur',message: 'Enter correctly '+item.fieldName, validator: validateMobile}],
        alyWebUrl: [{ required: item.required, trigger: 'blur',message: 'Enter correctly '+item.fieldName}], // , validator: validateWebUrl
        other:{required:item.required, message: item.fieldName+' Cannot be empty', trigger: 'change'},
        select:{required:item.required, message: 'Please choose ', trigger: 'change',validator:function(rule, value, callback){
          if( value || rule.required ){
              if (value == '') {
                callback(new Error('Please choose '+item.fieldName))
              } else {
                callback()
              }
          }else{
              callback()
          }
        }},
        alyEmail: [{ required: item.required, trigger: 'blur', message: "Enter correctly "+item.fieldName, validator: validateEmail}],
      }
      switch (item.fieldKey){
        case 'alyCountry':
          temp = 'alyCountry'
          break;
        case 'alyProvince':
          temp = 'alyProvince'
          break;
        case 'alyCity':
          temp = 'alyCity'
          break;
        case 'aLyLegalEmail':
        case 'alyEmail':
          temp = 'alyEmail'
          break;
        case 'alyLegalZipCode':
        case 'alyZipCode':
          temp = 'alyZipCode'
          break;
        case 'alyLegalRank':
        case 'alyPosition':
          temp = 'alyPosition'
          break;
        case 'alyLegalMobile':
        case 'alyMobile':
          temp = 'alyMobile'
          break;
        case 'alySName':
        case 'alyWebUrl':
          temp = 'alyWebUrl'
          break;
        case 'alyComName':
        case 'alyComEName':
            temp = 'alyComName'
            break;
        case 'aLyLegal':
        case 'alyPsnName':
            temp = 'alyName'
            break;
        case 'aLyLegalFax':
        case 'aLyLegalTel':
        case 'alyTel':
        case 'alyFax':
            temp = item.fieldKey
            break;
        case 'aLyLegalAddress':
        case 'alyAddress':
        case 'alyEAddress':
            temp = 'alyAddress'
            break;
        case 'alyPdtType':
          temp = 'select'
          break;
        default: 
            temp = 'other'
            break
      }
      return rulesData[temp]
    },
    // 获取城市选项
    getCitys() {
      api.getallcitysbyprovince({
        exhId: this.exhId || sessionStorage.getItem('exhId'),
        zptProvince: this.form.alyProvince
      }).then((res) => {
        this.citysList = res.data.data
      })
    },
    // 获取省份选项
    getallprovinces() {
      api.getallprovinces({
        exhId: this.exhId || sessionStorage.getItem('exhId')
      }).then((res) => {    
        this.provinceList = res.data.data
      })
    },
    //获取国家选项
    getCountrys() {
      api.getallcountrys({
        exhId: this.exhId || sessionStorage.getItem('exhId')
      }).then((res) => {    
        // console.log(res,'0-0-')
        this.countryList = [{zptArea: "国内",zptECity: "China",zptCity: "中国"}, ...res.data.data]
      })
    },
    //国家切换
    changeCountry(){
      if (this.form.alyCountry != '中国') {
        this.form.alyProvince= ''
        this.form.alyCity =''
        this.provinceList = []
        this.citysList =[]
      } else {
        // 获取省份
        this.getallprovinces()
      }
    },
    //切换省份
    changeProvince() {
      this.form.alyCity =''
      this.getCitys()
    },

    //获取数据
    getregisterconfig(){
      api.getsaasfield({type:"actorapply"}).then(res => {
        if (res.data.code === 200) {
          this.formList.list =[]
          for(var i = 0;i<res.data.data.length;i++){
            if(res.data.data[i].enable == 1){
              this.formList.list.push(res.data.data[i])
            }
          }
          for(var j=0;j<this.formList.list.length;j++){
            this.$set( this.form,this.formList.list[j].fieldKey,'')
          }
          this.loading.close();
        }
      })
    },
    closeTip(){
       this.showRegistText = false
    },
    changeCheck(){
      this.showRegistText = !this.showRegistText
    },
    onSubmit() {
      if( this.subimtStatu ){
        return false
      }
      this.$refs['singUp'].validate((valid) => {
        if (valid) {
          // if(!this.registerFlan){
          //   this.showRegistText = true;
          //   this.$notify({
          //     title: '警告',
          //     message: '请查看注册协议',
          //     type: 'warning'
          //   });
          //   return false
          // }
          this.subimtStatu = true
          // console.log('this.form',this.form)
          if (this.form.alyComName === '') {
            this.form.alyComName = this.form.alyComEName
          }
          var paramt = JSON.parse(JSON.stringify(this.form))
          paramt.exhId =  paramt.exhId.toString()
          // console.log('paramt.exhId',paramt.exhId)
          // console.log('paramt',paramt)
  
          // api.addactorapply(this.form).then((res) => {
          api.addactorapply(paramt).then((res) => {
            if (res.data.code == '200') {
              this.$notify({
                title: 'Submitted successfully',
                type: 'success',
                duration: 8000,
                customClass: 'center-notify'
              })
              this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
            }else{
                // this.$notify({
                //   title: 'Submission failed',
                //   type: 'error'
                // })
            }
            this.subimtStatu = false
          })

        } else {
          // this.$notify({
          //   title: '请检查表单填写项是否符合规范！',
          //   type: 'error'
          // })
          return false
        }
      })
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less">
.registBox{
  position: fixed;
  left:0;
  right:0;
  bottom:0;
  top:0;
  z-index: 99;
}
.registBox .icon{
  position: absolute;
  right:0;
  top:0;
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
}
.registBox .smallTitle{
  font-size: 18px;
  text-align: center;
  padding-bottom: 10px;
  font-weight: bold;
}
.registContent{
  font-size: 14px;
  position: absolute;
  width:650px;
  background: #fff;
  margin:auto;
  top:30%;
  left:0;
  right:0;
  padding:20px;
  border:2px solid #dedede
}
.registContent p{
  padding: 4px 0;
}
.center-notify {
  top: 50% !important;
  left: 50% !important;
  right: auto !important;
  transform: translate(-50%, -50%);
}
.title{
  text-align: center;
  font-size: 30px;
  // padding-top:40px;
}
.blue {
  color: #409eff;
}

// .title {
//  margin-bottom: 30px;
//}

.col-1-fix {
  padding-left: 0 !important;
}
.desc{
  font-size: 14px;
  line-height: 18px;
  padding: 10px;
}
.mz{
  font-size:14px;
  color:#999;
}
.btns{
  text-align: center;
  padding-top: 15px;
}
@media screen and (max-width:540px){

  .registContent{
    width:80%;
  }

  .addPro{
    width:85%;
    margin:auto;
    .el-form-item__label{
      font-size:14px;
    }
    .el-radio-group{
      label{
        padding:6px 0
      }
    }
    .el-input--small .el-input__inner{
      border:0;
      text-align: right;
      // padding-right: 45px;
      padding-right: 0;
    }
    .el-form-item{
      border-bottom: 1px solid #ededed;
    }
    .dash-upload{
      width:180px;
    }
    .noRequire .el-form-item__label::before{
      content: '';
      display: inline-block;
      width:10px;
    }
    .el-form-item__error{
      text-align: right;
      width:100%;
    }
  }
}
</style>
